import { useQuery } from '@tanstack/react-query';
import request from '@/services/api';

export const useSkillList = (params?: any) => {
  return useQuery({
    queryKey: ['skill-list', params],
    queryFn: async () => {
      const res = await request.get('/course-skill', { params });
      return res.data;
    }
  });
};

export const useCourseSkillList = useSkillList;
